import { Component, Input } from '@angular/core';
import { AttributeValue } from '../../../../../models/section-definition.model';

@Component({
  selector: 'lib-attribute-file-row',
  standalone: false,
  templateUrl: './attribute-file-row.component.html',
  styleUrls: ['./attribute-file-row.component.scss'],
})
export class AttributeFileRowComponent {
  @Input() attributeValue!: AttributeValue;

  downloadFile(url: string) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = this.getFileName(url);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => console.error('Download failed:', err));
  }

  getFileName(url: string): string {
    return url.split('/').pop() ?? 'download';
  }
}
